/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmManagement_FirmsSalesCoverageGridQueryVariables = Types.Exact<{
  firmId: Types.Scalars['UUID']['input'];
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.InvestorFirmRelationshipFilterInput>;
  order?: Types.InputMaybe<
    ReadonlyArray<Types.InvestorFirmRelationshipSortInput> | Types.InvestorFirmRelationshipSortInput
  >;
}>;

export type CrmManagement_FirmsSalesCoverageGridQuery = {
  readonly __typename?: 'Query';
  readonly investorFirmsGrid?: {
    readonly __typename?: 'InvestorFirmsGridCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly salesCoverage?: {
        readonly __typename?: 'SalesCoverageCollectionSegment';
        readonly totalCount: number;
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmRelationship';
          readonly employeeId: string;
          readonly employeeKey: string;
          readonly employeeName?: string | null;
          readonly employeeStatus: Types.RolodexRecordStatus;
          readonly firmId: string;
          readonly jobFunction?: Types.JobFunction | null;
          readonly lastUpdated: string;
          readonly relationshipType: Types.RelationshipType;
          readonly relationshipStatus: Types.RolodexRecordStatus;
        }> | null;
      } | null;
    }> | null;
  } | null;
};

export type CrmManagement_AdminFirmsSalesCoverageGridQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['UUID']['input'];
  firmId: Types.Scalars['UUID']['input'];
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.InvestorFirmRelationshipFilterInput>;
  order?: Types.InputMaybe<
    ReadonlyArray<Types.InvestorFirmRelationshipSortInput> | Types.InvestorFirmRelationshipSortInput
  >;
}>;

export type CrmManagement_AdminFirmsSalesCoverageGridQuery = {
  readonly __typename?: 'Query';
  readonly adminInvestorFirmsGrid?: {
    readonly __typename?: 'AdminInvestorFirmsGridCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly salesCoverage?: {
        readonly __typename?: 'SalesCoverageCollectionSegment';
        readonly totalCount: number;
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmRelationship';
          readonly employeeId: string;
          readonly employeeKey: string;
          readonly employeeName?: string | null;
          readonly employeeStatus: Types.RolodexRecordStatus;
          readonly firmId: string;
          readonly jobFunction?: Types.JobFunction | null;
          readonly lastUpdated: string;
          readonly relationshipType: Types.RelationshipType;
          readonly relationshipStatus: Types.RolodexRecordStatus;
        }> | null;
      } | null;
    }> | null;
  } | null;
};

export type FirmSalesCoverageGridItemFragment = {
  readonly __typename?: 'InvestorFirmRelationship';
  readonly employeeId: string;
  readonly employeeKey: string;
  readonly employeeName?: string | null;
  readonly employeeStatus: Types.RolodexRecordStatus;
  readonly firmId: string;
  readonly jobFunction?: Types.JobFunction | null;
  readonly lastUpdated: string;
  readonly relationshipType: Types.RelationshipType;
  readonly relationshipStatus: Types.RolodexRecordStatus;
};

export const FirmSalesCoverageGridItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirmSalesCoverageGridItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'employeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CrmManagement_FirmsSalesCoverageGridDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_FirmsSalesCoverageGrid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'InvestorFirmRelationshipFilterInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'InvestorFirmRelationshipSortInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesCoverage' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'skip' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'take' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'where' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'FirmSalesCoverageGridItem' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirmSalesCoverageGridItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'employeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_FirmsSalesCoverageGridQuery__
 *
 * To run a query within a React component, call `useCrmManagement_FirmsSalesCoverageGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_FirmsSalesCoverageGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_FirmsSalesCoverageGridQuery({
 *   variables: {
 *      firmId: // value for 'firmId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCrmManagement_FirmsSalesCoverageGridQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_FirmsSalesCoverageGridQuery,
    CrmManagement_FirmsSalesCoverageGridQueryVariables
  > &
    (
      | { variables: CrmManagement_FirmsSalesCoverageGridQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_FirmsSalesCoverageGridQuery,
    CrmManagement_FirmsSalesCoverageGridQueryVariables
  >(CrmManagement_FirmsSalesCoverageGridDocument, options);
}
export function useCrmManagement_FirmsSalesCoverageGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_FirmsSalesCoverageGridQuery,
    CrmManagement_FirmsSalesCoverageGridQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_FirmsSalesCoverageGridQuery,
    CrmManagement_FirmsSalesCoverageGridQueryVariables
  >(CrmManagement_FirmsSalesCoverageGridDocument, options);
}
// @ts-ignore
export function useCrmManagement_FirmsSalesCoverageGridSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_FirmsSalesCoverageGridQuery,
    CrmManagement_FirmsSalesCoverageGridQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_FirmsSalesCoverageGridQuery,
  CrmManagement_FirmsSalesCoverageGridQueryVariables
>;
export function useCrmManagement_FirmsSalesCoverageGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_FirmsSalesCoverageGridQuery,
        CrmManagement_FirmsSalesCoverageGridQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_FirmsSalesCoverageGridQuery | undefined,
  CrmManagement_FirmsSalesCoverageGridQueryVariables
>;
export function useCrmManagement_FirmsSalesCoverageGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_FirmsSalesCoverageGridQuery,
        CrmManagement_FirmsSalesCoverageGridQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_FirmsSalesCoverageGridQuery,
    CrmManagement_FirmsSalesCoverageGridQueryVariables
  >(CrmManagement_FirmsSalesCoverageGridDocument, options);
}
export type CrmManagement_FirmsSalesCoverageGridQueryHookResult = ReturnType<
  typeof useCrmManagement_FirmsSalesCoverageGridQuery
>;
export type CrmManagement_FirmsSalesCoverageGridLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_FirmsSalesCoverageGridLazyQuery
>;
export type CrmManagement_FirmsSalesCoverageGridSuspenseQueryHookResult = ReturnType<
  typeof useCrmManagement_FirmsSalesCoverageGridSuspenseQuery
>;
export type CrmManagement_FirmsSalesCoverageGridQueryResult = Apollo.QueryResult<
  CrmManagement_FirmsSalesCoverageGridQuery,
  CrmManagement_FirmsSalesCoverageGridQueryVariables
>;
export const CrmManagement_AdminFirmsSalesCoverageGridDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_AdminFirmsSalesCoverageGrid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'InvestorFirmRelationshipFilterInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'InvestorFirmRelationshipSortInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminInvestorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesCoverage' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'skip' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'take' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'where' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'FirmSalesCoverageGridItem' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirmSalesCoverageGridItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'employeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_AdminFirmsSalesCoverageGridQuery__
 *
 * To run a query within a React component, call `useCrmManagement_AdminFirmsSalesCoverageGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_AdminFirmsSalesCoverageGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_AdminFirmsSalesCoverageGridQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      firmId: // value for 'firmId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCrmManagement_AdminFirmsSalesCoverageGridQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_AdminFirmsSalesCoverageGridQuery,
    CrmManagement_AdminFirmsSalesCoverageGridQueryVariables
  > &
    (
      | { variables: CrmManagement_AdminFirmsSalesCoverageGridQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_AdminFirmsSalesCoverageGridQuery,
    CrmManagement_AdminFirmsSalesCoverageGridQueryVariables
  >(CrmManagement_AdminFirmsSalesCoverageGridDocument, options);
}
export function useCrmManagement_AdminFirmsSalesCoverageGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_AdminFirmsSalesCoverageGridQuery,
    CrmManagement_AdminFirmsSalesCoverageGridQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_AdminFirmsSalesCoverageGridQuery,
    CrmManagement_AdminFirmsSalesCoverageGridQueryVariables
  >(CrmManagement_AdminFirmsSalesCoverageGridDocument, options);
}
// @ts-ignore
export function useCrmManagement_AdminFirmsSalesCoverageGridSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_AdminFirmsSalesCoverageGridQuery,
    CrmManagement_AdminFirmsSalesCoverageGridQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AdminFirmsSalesCoverageGridQuery,
  CrmManagement_AdminFirmsSalesCoverageGridQueryVariables
>;
export function useCrmManagement_AdminFirmsSalesCoverageGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AdminFirmsSalesCoverageGridQuery,
        CrmManagement_AdminFirmsSalesCoverageGridQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AdminFirmsSalesCoverageGridQuery | undefined,
  CrmManagement_AdminFirmsSalesCoverageGridQueryVariables
>;
export function useCrmManagement_AdminFirmsSalesCoverageGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AdminFirmsSalesCoverageGridQuery,
        CrmManagement_AdminFirmsSalesCoverageGridQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_AdminFirmsSalesCoverageGridQuery,
    CrmManagement_AdminFirmsSalesCoverageGridQueryVariables
  >(CrmManagement_AdminFirmsSalesCoverageGridDocument, options);
}
export type CrmManagement_AdminFirmsSalesCoverageGridQueryHookResult = ReturnType<
  typeof useCrmManagement_AdminFirmsSalesCoverageGridQuery
>;
export type CrmManagement_AdminFirmsSalesCoverageGridLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_AdminFirmsSalesCoverageGridLazyQuery
>;
export type CrmManagement_AdminFirmsSalesCoverageGridSuspenseQueryHookResult = ReturnType<
  typeof useCrmManagement_AdminFirmsSalesCoverageGridSuspenseQuery
>;
export type CrmManagement_AdminFirmsSalesCoverageGridQueryResult = Apollo.QueryResult<
  CrmManagement_AdminFirmsSalesCoverageGridQuery,
  CrmManagement_AdminFirmsSalesCoverageGridQueryVariables
>;
